module.exports = __webpack_public_path__ + "img/culture_04.afe541a5.png";